import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Col, Row } from 'react-bootstrap';

interface KPIData {
  date: string;
  count: number;
}

interface CrmStatCardProps {
  icon: IconProp;
  color: string;
  label: string;
  title: string;
  value: number;
  data?: KPIData[];
  formatValue?: boolean;
}

const KnowledgeCard = ({
  icon,
  color,
  label,
  title,
  value,
  formatValue = false
}: CrmStatCardProps) => {
  // Función para formatear valores grandes
  const displayValue = () => {
    if (typeof value === 'string') return value;

    if (formatValue && typeof value === 'number') {
      if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
      if (value >= 1000) return `${(value / 1000).toFixed(1)}K`;
    }

    return value.toLocaleString(); // Agregar separadores de miles
  };

  return (
    <Card className="h-100" style={{ minWidth: '15rem' }}>
      <Card.Body className="p-3 pt-0 pb-1">
        <Row className="mb-0">
          <Col
            className="d-flex align-items-center"
            xs={7}
            sm={7}
            md={7}
            xl={7}
            xxl={7}
          >
            <div className={`d-flex pt-1`}>
              <FontAwesomeIcon
                icon={icon}
                className={`text-${color} fs-6 z-1 ms-2`}
              />
            </div>
            <p className="text-body-tertiary fs-10 mb-0 ms-2 mt-2 lh-1">
              {label} <br />
              <span className="p-0 fs-8 fw-bold lh-1 text-body-emphasis">
                {title}
              </span>
            </p>
          </Col>
          <Col
            className={`text-${color} mt-2 fs-6 fw-bold mb-0 pt-1 text-end`}
            xs={5}
            sm={5}
            md={5}
            xl={5}
            xxl={5}
          >
            {displayValue()}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default KnowledgeCard;
